import { WorkColumns } from "@lhd/types";
import { MouseClickRightSvg } from "@lhd/assets";
import { IData } from "../hook";
import { useMemo } from "react";
import { useDeepCompareMemoize } from "@lhd/hooks";

export const handleData = (data: IData[], workColumnData: WorkColumns[]) => {
  const lengthData = data?.length;
  const lastIndex = data?.[lengthData - 1]?.id
    ? data?.[lengthData - 1]?.id + 1
    : lengthData;

  return [
    ...data,
    ...Array.from(
      Array(data.length > 1000 ? 0 : 1000 - data.length).keys(),
    ).map((_, index) => {
      return {
        id: index + lastIndex,
        month: "",
        year_cycle: "",
        worker_id: "",
        position_id: "",
        ...workColumnData.reduce(
          (curr: any, arr: any) => ({
            ...curr,
            [`${arr.title}-${arr.id}`]: "",
          }),
          {},
        ),
        time_normal: null,
        time_ot: null,
        time_night: null,
        time_offday: null,
        time_holiday: null,
        time_delay: null,
        time_early: null,
        memo: "",
        time_work_hour: null,
        time_non_work_hour: null,
        day_working: null,
        day_absent: null,
        day_off_full_pay: null,
        isCreate: true,
      };
    }),
  ];
};

export const MONTHLY = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const useColumns = (additionalField: WorkColumns[], size?: any) => {
  return useMemo(
    () => [
      {
        columnId: "index",
        label: "No.",
        type: "text",
        width: 40,
        editTable: true,
        icon: <></>,
      },
      {
        columnId: "year_cycle",
        label: "年度",
        type: "text",
        width: 100,
        icon: <></>,
      },
      {
        columnId: "month",
        label: "月度",
        type: "text",
        width: 150,
        icon: <></>,
      },
      {
        columnId: "worker_id",
        label: "社員",
        type: "text",
        width: 215,
        icon: <MouseClickRightSvg size={size} />,
      },
      {
        columnId: "position_id",
        label: "役職",
        type: "text",
        width: 215,
        icon: <MouseClickRightSvg size={size} />,
      },
      ...additionalField.map((item) => ({
        columnId: `${item.title}-${item.id}`,
        label: item.title,
        unit: item?.unit || "",
        type: "numberformat",
        width: 150,
        values: null,
        icon: <></>,
      })),
      {
        columnId: "time_normal",
        label: "所定時間",
        type: "numberformat",
        width: 150,
        icon: <></>,
      },
      {
        columnId: "time_ot",
        label: "残業時間",
        type: "numberformat",
        width: 150,
        icon: <></>,
      },
      {
        columnId: "time_night",
        label: "深夜時間",
        type: "numberformat",
        width: 150,
        icon: <></>,
      },
      {
        columnId: "time_offday",
        label: "所定休日時間",
        type: "numberformat",
        width: 150,
        icon: <></>,
      },
      {
        columnId: "time_holiday",
        label: "法定休日時間",
        type: "numberformat",
        width: 150,
        icon: <></>,
      },
      {
        columnId: "time_delay",
        label: "遅刻時間",
        type: "numberformat",
        width: 150,
        icon: <></>,
      },
      {
        columnId: "time_early",
        label: "早退時間",
        type: "numberformat",
        width: 150,
        icon: <></>,
      },
      {
        columnId: "memo",
        label: "M E Ｍ Ｏ",
        type: "text",
        width: 415,
        icon: <></>,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useDeepCompareMemoize([additionalField, size]),
  );
};

// export const useColumnsDay = (additionalField: WorkColumns[]) => {
//   return useMemo(
//     () => [
//       {
//         columnId: "index",
//         label: "No.",
//         type: "text",
//         width: 40,
//         editTable: true,
//         icon: <></>,
//       },
//       {
//         columnId: "year_cycle",
//         label: "年度",
//         type: "text",
//         width: 100,
//         icon: <></>,
//       },
//       {
//         columnId: "month",
//         label: "月度",
//         type: "text",
//         width: 150,
//         icon: <></>,
//       },
//       {
//         columnId: "worker_id",
//         label: "社員",
//         type: "text",
//         width: 215,
//         icon: <MouseClickRightSvg size={size} />,
//       },
//       {
//         columnId: "position_id",
//         label: "役職",
//         type: "text",
//         width: 215,
//         icon: <MouseClickRightSvg size={size} />,
//       },
//       ...additionalField.map((item) => ({
//         columnId: `${item.title}-${item.id}`,
//         label: item.title,
//         unit: item?.unit || "",
//         type: "number",
//         width: 150,
//         values: null,
//         icon: <></>,
//       })),
//       {
//         columnId: "day_working",
//         label: "出勤日数",
//         type: "number",
//         width: 150,
//         icon: <></>,
//       },
//       {
//         columnId: "day_absent",
//         label: "欠勤日数",
//         type: "number",
//         width: 150,
//         icon: <></>,
//       },
//       {
//         columnId: "day_off_full_pay",
//         label: "有休日数",
//         type: "number",
//         width: 150,
//         icon: <></>,
//       },
//       {
//         columnId: "memo",
//         label: "M E Ｍ Ｏ",
//         type: "text",
//         width: 415,
//         icon: <></>,
//       },
//     ],
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     useDeepCompareMemoize([additionalField]),
//   );
// };

export const emptyData = {
  month: "",
  year_cycle: "",
  worker_id: "",
  position_id: "",
  time_normal: null,
  time_ot: null,
  time_night: null,
  time_offday: null,
  time_holiday: null,
  time_delay: null,
  time_early: null,
  memo: "",
  time_work_hour: null,
  time_non_work_hour: null,
  day_working: null,
  day_absent: null,
  day_off_full_pay: null,
  isCreate: true,
};

const WORKS_META_FIELDS = new Set([
  "id",
  "index",
  "isCreate",
  "isDeleted",
  "isTotal",
  "sort_index",
  "workId",
  "user_id",
  "year_cycle",
]);

const isEmptyCellValue = (value: unknown) => {
  if (value == null || value === "" || value === false) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  return false;
};

const hasMeaningfulValue = (value: unknown) => !isEmptyCellValue(value);

const hasWorksIdentity = (record: any) =>
  !!record.worker_id?.toString?.().trim() ||
  (record.month != null && record.month !== "");

export const hasWorksEnteredData = (record: any) => {
  if (record.index === "合計金") return false;

  const dataEntries = Object.entries(record).filter(
    ([key]) => !WORKS_META_FIELDS.has(key),
  );

  const hasOtherMeaningfulData = dataEntries.some(([, value]) =>
    hasMeaningfulValue(value),
  );

  if (!record.workId) {
    return hasWorksIdentity(record) || hasOtherMeaningfulData;
  }

  if (hasWorksIdentity(record)) {
    return true;
  }

  // Persisted row without worker/month: hide API ghost shells (only 0/null).
  return dataEntries.some(([, value]) => {
    if (isEmptyCellValue(value)) return false;
    if (typeof value === "number" && value === 0) return false;
    return true;
  });
};

export const compactWorksRows = (rows: IData[]) =>
  rows.filter((item) => item.index !== "合計金" && hasWorksEnteredData(item));

export const checkInvalid = (
  data: IData,
  fields?: string[],
  countFieldValidate?: number,
) => {
  let result = false;
  let haveData = false;
  let countFieldInvalid = 0;
  if (fields) {
    fields.forEach((fieldItem) => {
      if (!data?.[fieldItem as keyof IData]) {
        result = true;
        countFieldInvalid = countFieldInvalid + 1;
      } else {
        haveData = true;
      }
    });
  } else {
    Object.keys(data).forEach((keyItem: string) => {
      if (!data?.[keyItem as keyof IData]) {
        result = true;
      } else {
        haveData = true;
      }
    });
  }
  return {
    invalid:
      countFieldValidate === undefined
        ? result
        : result && fields && countFieldInvalid === countFieldValidate,
    haveData,
  };
};

export const getUnit = (columnId: string, unit: string) => {
  if (
    [
      "time_normal",
      "time_ot",
      "time_night",
      "time_offday",
      "time_holiday",
      "time_delay",
      "time_early",
      "time_work_hour",
      "time_non_work_hour",
    ].includes(columnId)
  ) {
    return "h";
  }
  if (["day_working", "day_absent", "day_off_full_pay"].includes(columnId)) {
    return "d";
  }
  return unit;
};

export const work_special_fields_convert_attr = ["worker_id", "position_id"];
